module.exports = __webpack_public_path__ + "static/tmweddingInvites-bd6dc12a5c75ec65004eaf25c71c4ea1.png";